import { jsx, Fragment } from "react/jsx-runtime";
import { Badge, SvgIcon } from "@mui/material";
const sizes = {
  xxs: 10,
  xs: 12,
  sm: 18,
  md: 24,
  lg: 36,
  xl: 48
};
function Icon({ size = "md", badge, ...props }) {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Badge,
    {
      color: props.badgeColor ?? "primary",
      ...typeof badge !== "undefined" && {
        badgeContent: badge
      },
      children: /* @__PURE__ */ jsx(SvgIcon, { sx: { fontSize: sizes[size] }, ...props, children: props.children })
    }
  ) });
}
export {
  Icon
};
